module.exports = __webpack_public_path__ + "static/media/mob-baseball.07db48c9.webp";